export enum EmailSourceType {
  Event = 'event_app',
  Library = 'library',
}
